import {
  faAdd,
  faAngleRight,
  faPlay,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useNavigate } from "react-router-dom";
import CustomEditor from "../../../components/common/CustomEditor";
import ImageUpload from "../../../components/common/ImageUpload";
import CustomEditorHosted from "../../../components/common/CustomEditorHosted";

const AddArticle = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="wrap_header p-0">
        <div className="breadcrumps">
          <a onClick={() => navigate("/colleges-list")}>Club</a>
          <FontAwesomeIcon icon={faAngleRight} />
          <a onClick={() => navigate(-1)}>Club Details</a>
          <FontAwesomeIcon icon={faAngleRight} />
          <a>Add/Edit Club Article</a>
        </div>
        <div className="subheader-right-btm subheader-right-btn3">
          <button
            className="btn btn-purple"
            type="button"
            onClick={() => navigate(-1)}
          >
            Discard
          </button>
          <button type="submit" className="btn btn-purple discard">
            Save
          </button>
        </div>
      </div>
      <div className="mb-3">
        <h1>
          <FontAwesomeIcon className="play-icon" icon={faPlay} />
          Title
        </h1>
        <CustomEditorHosted />
      </div>
      <div className="mb-3">
        <h1>
          <FontAwesomeIcon className="play-icon" icon={faPlay} />
          Body
        </h1>
        <CustomEditorHosted />
      </div>
      <div className="mb-3">
        <h1>
          <FontAwesomeIcon className="play-icon" icon={faPlay} />
          Upload Image
        </h1>
        <div>
          <ImageUpload
            inputId="img1"
            imgId="img"
            // src={uploadImage}
            alt="clubs image"
            // name=
            // setValue={setValue}
            // register={register}
            type="url"

            // defaultValues={item?.images?.club_image}
          />
        </div>
      </div>
      <div className="mb-3 col-md-4">
        <h1>
          <FontAwesomeIcon className="play-icon" icon={faPlay} />
          Add media files
        </h1>
        <input className="form-control" placeholder="Enter name here" />

        <div className="subheader-right-btm ">
          <button type="button" className="btn-purple discard">
            <FontAwesomeIcon icon={faAdd} /> Add More
          </button>
          <button type="button" className="btn-purple ">
            <FontAwesomeIcon icon={faTrash} /> Delete
          </button>
        </div>
      </div>
      <div className="mb-3 col-md-4">
        <h1>
          <FontAwesomeIcon className="play-icon" icon={faPlay} />
          Authors
        </h1>
        <input className="form-control" placeholder="Enter name here" />

        <div className="subheader-right-btm ">
          <button type="button" className="btn-purple discard">
            <FontAwesomeIcon icon={faAdd} /> Add More
          </button>
          <button type="button" className="btn-purple ">
            <FontAwesomeIcon icon={faTrash} /> Delete
          </button>
        </div>
      </div>
      <div className="mb-3 col-md-4">
        <h1>
          <FontAwesomeIcon className="play-icon" icon={faPlay} />
          Journal Name –
        </h1>
        <input className="form-control" placeholder="Enter name here" />
      </div>
      <div className="mb-3">
        <h1>
          <FontAwesomeIcon className="play-icon" icon={faPlay} />
          Citation text –
        </h1>
        <CustomEditorHosted />
      </div>
    </div>
  );
};

export default AddArticle;
